'use client'
import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'

import TwoColumnsWithBackgroundImage from '@/components/TwoColumnsWithBackgroundImage'

const LogixboardCalloutQuote = () => {
    const { mdScreen } = useDevice()
    return (
        <TwoColumnsWithBackgroundImage
            backgroundImage={'/images/ets-maps/ets-explorer-desktop-22.png'}
            mobileBackgroundImage={'/images/logistics/ais-tracking-mobile.png'}
            sx={{
                minHeight: '480px',
            }}
            leftSide={
                <Box
                    sx={{
                        gap: mdScreen ? 3 : 4,
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                    }}
                >
                    <Text variant={mdScreen ? 'h5' : 'h4'} sx={{ maxWidth: '750px' }}>
                        Failing to meet these requests meant losing revenue; fulfilling these
                        requests meant growing revenue.
                    </Text>
                </Box>
            }
            reversedOnMobile={false}
        />
    )
}

export default LogixboardCalloutQuote
